import { render, staticRenderFns } from "./Valores.vue?vue&type=template&id=0b885c13"
import script from "./Valores.vue?vue&type=script&lang=js"
export * from "./Valores.vue?vue&type=script&lang=js"
import style0 from "./Valores.vue?vue&type=style&index=0&id=0b885c13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports